module.exports = __webpack_public_path__ + "static/media/img_mapping_02.3eeee2ac.png";